import ApiService from "../../../../services/ApiService";
import translate from "../../../../services/Translate";
import { MeetingAttendanceStatus } from "./Attendance.d";

export const fetchMeetingAttendance = (meetingId: string, setAttendance: Function, setIsLoading: Function) => {
  setIsLoading(true);
  ApiService.get(`meetings/${meetingId}/attendance`)
    .then((response) => {
      setAttendance(response.data.attendance);
    })
    .catch((err) => {
      console.error("Error fetching meeting attendance:", err);
    })
    .finally(() => {
      setIsLoading(false);
    });
};

export const updateMultipleAttendance = (
  meetingId: string,
  userIds: number[],
  status: MeetingAttendanceStatus,
  language: string,
  setIsLoading: Function,
  onSuccess: Function
) => {
  if (userIds.length === 0) {
    console.warn("No users selected for attendance update");
    return;
  }

  setIsLoading(true);

  Promise.all(userIds.map((userId) => ApiService.put(`meetings/${meetingId}/users/${userId}/attendance`, { status })))
    .then(() => {
      alert(translate(language, "PAGES.MEETING.SUCCESS.UPDATED_ATTENDANCE"));
      onSuccess();
    })
    .catch((err) => {
      console.error("Error updating multiple attendance statuses:", err);
      const errorMessage = err?.data?.error?.message
        ? err.data.error.message
        : translate(language, "PAGES.MEETING.ERRORS.UPDATED_ATTENDANCE");
      alert(errorMessage);
    })
    .finally(() => {
      setIsLoading(false);
    });
};

export const fetchAttendanceSheet = (meetingId: string, language: string) => {
  ApiService.post(`meetings/${meetingId}/attendance/document`, {})
    .then((response) => {
      const pdfLink = response.data.document_link;
      if (!pdfLink) {
        throw new Error("PDF link not found in response");
      }

      fetch(pdfLink)
        .then((res) => res.blob())
        .then((blob) => {
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.setAttribute("download", `attendance_sheet_${meetingId}.pdf`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
    })
    .catch((err) => {
      console.error("Error fetching attendance sheet:", err);
      alert(translate(language, "PAGES.MEETING.ERRORS.ATTENDANCE_SHEET"));
    });
};

export const generateAttendanceLink = (
  meetingId: string,
  language: string,
  setIsLoading: Function,
  successCallback: Function
) => {
  setIsLoading(true);
  ApiService.post(`meetings/${meetingId}/attendance/link`, {})
    .then(() => {
      alert(translate(language, "PAGES.MEETING.SUCCESS.GENERATE_ATTENDANCE_LINK"));
      successCallback();
    })
    .catch((err) => {
      console.error("Error generating attendance link:", err);
      alert(translate(language, "PAGES.MEETING.ERRORS.GENERATE_ATTENDANCE_LINK"));
    })
    .finally(() => {
      setIsLoading(false);
    });
};

export const lockAttendance = (
  meetingId: string,
  language: string,
  setIsLoading: Function,
  successCallback: Function
) => {
  setIsLoading(true);
  ApiService.post(`meetings/${meetingId}/attendance/lock`, {})
    .then(() => {
      alert(translate(language, "PAGES.MEETING.SUCCESS.LOCK_ATTENDANCE"));
      successCallback();
    })
    .catch((err) => {
      console.error("Error locking attendance:", err);
      alert(translate(language, "PAGES.MEETING.ERRORS.LOCK_ATTENDANCE"));
    })
    .finally(() => {
      setIsLoading(false);
    });
};

export const syncEdusignAttendance = (
  meetingId: string,
  language: string,
  setLoading: Function,
  onSuccess: Function
) => {
  setLoading(true);
  ApiService.post(`meetings/${meetingId}/attendance/sync-edusign`, {})
    .then(() => onSuccess())
    .catch((err) => {
      console.error("Error synchronizing attendance from edusign :", err);
      alert(translate(language, "PAGES.MEETING.ERRORS.SYNC_EDUSIGN_ATTENDANCE"));
    })
    .finally(() => setLoading(false));
};
